<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="我的收货地址" left-arrow @click-left="$router.go(-1)" />
    </van-sticky>
    <!-- 列表 -->
    <div class="address-list" v-if="listData.length > 0">
      <div class="address-item" v-for="(item, index) in listData" :key="index">
        <div class="address-item-content" @click="selectAddress(item)">
          <div class="itemTopWrap" style="overflow:hidden;">
            <div class="leftEl">
              <div class="item-top">
                <span class="address-item-content-name">
                  {{
                  item.name
                  }}
                </span>
                <span class="address-item-content-phone">{{ item.phone }}</span>
              </div>
              <div class="address-item-content-address van-ellipsis">{{ item.address }}</div>
            </div>
          </div>
          <div class="address-item-ctr">
            <div class="address-item-ctr-left" @click.stop="defaultAddress(item.id,item.is_check)">
              <van-icon v-if="item.is_check == 0" name="circle"></van-icon>
              <van-icon color="#FF6500" name="checked" v-else></van-icon>
              <span>默认地址</span>
            </div>
            <div class="address-item-ctr-right">
              <span @click.stop="editAddress(item)">
                <van-icon name="edit" />编辑
              </span>
              <span @click.stop="delAddress(item.id)">
                <van-icon name="delete" />删除
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="noData">暂无数据!</div>
    <!-- 新增 -->
    <van-button class="addBtn" @click="$router.push({ path: 'editAddress' })">新增地址</van-button>
  </div>
</template>
<script>
import { addressList, delAddress, isCheck } from "@/api/personal";
import eventBus from "../../utils/emptyVue";
export default {
  data() {
    return {
      listData: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getList() {
      addressList().then(res => {
        this.listData = res;
      });
    },
    editAddress(item) {
      this.$router.push({
        path: "editAddress",
        query: { item: item }
      });
    },
    //选择收货地址
    selectAddress(item) {
      // console.log("当前地址:", item);
      // eventBus.$emit("select_address",'111');

      if (this.$route.query.type != undefined) {
        if (this.$route.query.type == 1) {
          localStorage.setItem("chooseAddress", JSON.stringify(item));
          this.$router.go(-1);
        }
      }
    },
    // 设置默认地址
    defaultAddress(id, status) {
      let msg =
        status == 0
          ? "是否设置此地址为默认地址？"
          : "是否取消此地址为默认地址？";
      let data = {
        id: id,
        is_check: !status
      };

      this.$dialog
        .confirm({
          title: "设置默认地址",
          message: msg
        })
        .then(() => {
          this.$toast.loading("loading...");
          isCheck(data).then(resp => {
            this.$toast("设置成功");
            this.getList();
          });
        })
        .catch(() => {
          this.$toast("取消操作");
        });
    },
    // 删除地址
    delAddress(id) {
      this.$dialog
        .confirm({
          title: "删除地址",
          message: "是否删除该地址?"
        })
        .then(() => {
          delAddress(id).then(res => {
            this.$toast("删除成功");
            this.getList();
          });
        })
        .catch(() => {
          this.$toast("取消操作");
        });
    }
  }
};
</script>
<style lang="less" scoped>
.wrap {
  height: 100vh;
  background: #f9f9f9;
  position: relative;
}
.address-list {
  .address-item {
    background: #fff;
    padding: 8px 22.5px 10.5px 15px;
    box-sizing: border-box;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    .address-item-content {
      font-size: 13px;
      color: #333;
      width: 100%;
      .item-top {
        margin-bottom: 10.5px;
      }
      .address-item-content-name {
        margin-right: 14.5px;
      }
      .address-item-content-phone {
        color: #333;
        font-size: 13px;
      }
    }
    .itemRight {
      color: #999999;
      font-size: 13px;
      margin-top: 20px;
      position: relative;
    }
    .address-item-ctr {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      margin-top: 13px;
      .address-item-ctr-left {
        display: flex;
        align-items: center;
        .van-icon {
          margin-right: 10px;
          font-size: 16px;
        }
      }

      .address-item-ctr-right {
        width: 120px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .van-icon {
          margin-right: 8px;
        }
      }
    }
  }
}

.addBtn {
  width: 100%;
  height: 49px;
  line-height: 49px;
  background: #fe881e;
  position: fixed;
  left: 0;
  color: #fff;
  text-align: center;
  bottom: 0;
  font-size: 20px;
}
</style>
